module.exports = __webpack_public_path__ + "static/media/livecasinoLobby.16d18b4a.svg";